import { TextField,InputAdornment,IconButton } from "@mui/material";
import { Visibility,VisibilityOff } from "@mui/icons-material";
import { useState } from "react";
import { darkFieldSx } from "./darkFieldStyles";

const CustomInput = ({ label,color,error,focused,placeHolder,name, value,type,onChange,onBlur,optional,autoComplete,helperText,dark, ...props }) => {
  const [showPassword,setShowPassword]=useState(false);

  const handleClickShowPassword=()=>{
    setShowPassword(prev=>!prev)
  }

  const showLabel = !dark && label;
  const fieldPlaceholder = dark ? (placeHolder || label || '') : placeHolder;

  return (
    <TextField
      variant="outlined"
      helperText={helperText}
      color={color}
      required={optional ? false : !dark}
      label={showLabel ? label : undefined}
      focused={focused}
      fullWidth
      placeholder={fieldPlaceholder}
      value={value}
      name={name}
      type={type=='password'?(!showPassword&&'password'):type}
      onChange={onChange}
      onBlur={onBlur}
      error={error}
      sx={{ my: "5px", ...(dark ? darkFieldSx : {}) }}
      InputProps={{ sx: { height: dark ? 48 : 45, fontSize: 18 }, 
      endAdornment:type=='password'?
        <InputAdornment position="end">
          <IconButton
            aria-label="toggle password visibility"
            onClick={handleClickShowPassword}
            edge="end"
          >
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>:null
    }}
      inputProps={{ style: { fontSize: 18, color: dark ? '#fff' : undefined } }}
      InputLabelProps={{ style: { fontSize: 18,} }} // font size of input label
      autoComplete={autoComplete}
      {...props}
    />
  );
};

export default CustomInput;
